module.exports = __webpack_public_path__ + "static/img/m1.243cab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/m1.png
// module id = Kvbb
// module chunks = 3